import { Modal, Button } from "flowbite-react";
import { useTranslation } from "react-i18next";

interface AlertModalProps {
  show: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  isDisabled?: boolean;
  confirmColor?: "blue" | "red" | "green" | "yellow" | "gray";
  showCancel?: boolean;
}

const AlertModal: React.FC<AlertModalProps> = ({
  show,
  onClose,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  isDisabled = false,
  confirmColor = "blue",
  showCancel = true,
}) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    } else {
      onClose();
    }
  };

  return (
    <Modal show={show} onClose={onClose} size="md">
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">
            {title || t("common.alert", "Alert")}
          </h3>
          <button
            type="button"
            className="text-gray-400 hover:text-gray-600"
            onClick={onClose}
          >
            <span className="sr-only">{t("common.close", "Close")}</span>
            <svg
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="mb-6">
          <p className="text-gray-700 leading-relaxed">{message}</p>
        </div>

        <div className="flex gap-3 justify-end">
          {showCancel && (
            <Button color="gray" onClick={onClose}>
              {cancelText || t("common.cancel", "Cancel")}
            </Button>
          )}
          <Button
            color={confirmColor}
            onClick={handleConfirm}
            disabled={isDisabled}
          >
            {confirmText || t("common.continue", "Continue")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AlertModal;
